module.exports = `
<div class="modal-content policy-font">
    <div class="modal-body">
        <p class=MsoNormal align=center style='text-align:center'><span
                style='font-family:"Calibri","sans-serif"'><b><span style='font-family:
"Source Sans Pro","serif"'>Tüzel Kişi Temsilcisi Aydınlatma Formu</span></b></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>&nbsp;</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>Veri sorumlusu şirketimiz Otosor
Otomotiv Anonim Şirketi (&quot;</span></span><span style='font-family:"Calibri","sans-serif"'><b><span
                style='font-family:"Source Sans Pro","serif"'>Otosor</span></b></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>&quot;</span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'> ve/veya “</span></span><span
                style='font-family:"Calibri","sans-serif"'><b><span style='font-family:
"Source Sans Pro","serif"'>Şirket</span></b></span><span style='font-family:
"Calibri","sans-serif"'><span style='font-family:"Source Sans Pro","serif"'>”</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>) ile paylaştığınız kişisel verilerinizin 6698
sayılı Kişisel Verilerin Korunması Kanunu (&quot;</span></span><span
                style='font-family:"Calibri","sans-serif"'><b><span style='font-family:
"Source Sans Pro","serif"'>KVKK</span></b></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>&quot;) ve ikincil mevzuat
kapsamında güvenliğinin ve gizliliğinin temini, Otosor'un öncelikleri
arasındadır. Bu doğrultuda kişisel verilerinizin, veri sorumlusu olan Otosor
tarafından, aramızda herhangi bir hukuki ilişki kurulmasa dahi, toplanması,
depolanması, kullanılması, aktarılması, muhafaza edilmesi (bir diğer ifadeyle
işlenmesi) hakkında aşağıdaki bilgilendirmeleri dikkatinize sunmak isteriz.</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><b><span
                style='font-family:"Source Sans Pro","serif"'>1) Kişisel Verileriniz Hangi
Amaçlarla İşlenecektir?</span></b></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>Otosor ad-soya</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>dı, cep telefonu numarası, sabit telefon numarası,
T.C. kimlik numarası, e-posta adresi, kullanıcı adı, şifre ve </span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>imzanıza ilişkin kişisel verilerinizi aşağıda
belirtilen amaçlar dahilinde </span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>KVKK m.5/2 kapsamında açık
rızanız olmaksızın </span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>işleyebilecektir:</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>i) Temsilcisi olduğunuz şirket
ile Otosor arasında Araç Satış Sözleşmesi ve Araç Satış Sözleşmesi Özel
Şartları'nın (&quot;Sözleşme&quot;) akdedilmesi ve ifa edilebilmesi</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'> amacıyla Şirketimize iletilen taleplerin
değerlendirilmesi ve uygun bulunması halinde tarafınıza iş ortaklığı
ilişkisinin kurulması</span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>,</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>ii) Sözleşme kapsamında aracın
tarafınıza teslim/temin edilebilmesi,</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>iii) Otosor'un uygulanabilir sair
tüm yasal düzenlemeler kapsamında idari ve hukuki hak ve yükümlülüklerini
yerine getirebilmesi,</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>iv) Faaliyetlerimizin Otosor
politika ve prosedürlerine de uygun olarak yürütülmesinin temini</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>.</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><b><span
                style='font-family:"Source Sans Pro","serif"'>2) Kişisel Verileriniz Kimlere ve
Hangi Amaçlarla Aktarılacaktır</span></b></span><span style='font-family:"Calibri","sans-serif"'><b><span
                style='font-family:"Source Sans Pro","serif"'>?</span></b></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>Otosor kişisel verilerinizi
yukarıda belirtilen amaçlar dahilinde</span></span><span style='font-family:
"Calibri","sans-serif"'><span style='font-family:"Source Sans Pro","serif"'>
KVKK m.8/2 uyarınca</span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>:</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>i) Bakanlıklar, Ticaret Sicil
Müdürlükleri, Vergi Daireleri, noterlikler, Mahkemeler, savcılıklar, emniyet
teşkilatı ve sair her türlü kamu tüzel kişiler, yasal otoriteler ve resmi
mercilere,</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>ii) Otosor'un araç alım/satım
faaliyetlerini yürütmek üzere hizmet aldığı/verdiği ve/veya iş birliği yaptığı
yurtiçi</span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>nde</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'> </span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>bulunan finans, telekomünikasyon,
sigorta, arşiv, sunucu (server) barındırma, veri tabanı, veri merkezi, bulut
(cloud) platformları, kurye ve sair sektörlerde hizmet veren kurum ve
kuruluşlara</span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>,</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>i</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>ii</span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>) Yurtiçi</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>nde</span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'> </span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>bulunan hukuki, finansal, vergisel danışmanlarımız
ve denetçilerimize aktarabilecektir.</span></span></p>

        <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
normal'><span style='font-family:"Calibri","sans-serif"'><span
                lang=EN-GB style='font-family:"Source Sans Pro","serif"'>Ayrıca, işbu
Aydınlatma Formu’nda belirtilen amaçlar doğrultusunda, kişisel verileriniz KVKK
m.9/1 uyarınca açık rızanızın varlığı halinde yurt dışında mukim iş
ortaklarımıza, tedarikçilerimize ve hizmet sağlayıcılarımıza aktarılabilecektir.
</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>&nbsp;</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><b><span
                style='font-family:"Source Sans Pro","serif"'>3) Kişisel Verileriniz Hangi
Yöntemler ile Toplamaktayız?</span></b></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>Kişisel verileriniz Otosor
tarafından fiziksel olarak veya elektronik ortamda sözlü veya yazılı bir
şekilde tamamen veya kısmen otomatik yollarla / bir veri kayıt sisteminin parçası
olmak kaydıyla otomatik olmayan yollarla toplanabilecektir. Kişisel verileriniz
doğrudan doğruya sizden toplanabileceği gibi doğrudan veya dolaylı olarak ana
hissedarımız, iştiraklerimiz veya bağlı ortaklıklarımız, genel merkezimiz,
çağrı merkezimiz, kurumsal internet sitemiz, şube ve/veya bayilerimiz, resmi
kurum ve kuruluşlar ve/veya hizmet aldığımız ya da verdiğimiz gerçek ya da
tüzel üçüncü kişiler aracılığıyla da toplanabilecektir.</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><b><span
                style='font-family:"Source Sans Pro","serif"'>4) Kişisel Verilerinizi
Toplamamızın Hukuki Sebebi Nedir?</span></b></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>Kişisel verilerinizin Otosor
tarafından işlenmesinin hukuki sebe</span></span><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>bi KVKK m.5/2 kapsamında;</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'> (i) Otosor'un araç alım/satımı kapsamında kanuni
yükümlülüklerini yerine getirebilmesi ve (ii) Sözleşme'nin kurulması veya ifası
için kişisel verilerinizin işlenmesinin zorunlu olmasıdır. Hukuki sebebe
ilişkin detaylı bilgilendirme talep edilmesi halinde Otosor'a başvurulmasını
rica ederiz.</span></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><b><span
                style='font-family:"Source Sans Pro","serif"'>5) Veri Sahibi Olarak KVKK
Kapsamındaki Haklarınız Nelerdir?</span></b></span></p>

        <p class=MsoNormal style='text-align:justify'><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>Otosor tarafından işlenen kişisel
verileriniz bakımından Otosor'a başvurarak, kişisel verilerinizin (i) işlenip
işlenmediğini öğrenme, (ii) işlenmiş ise bilgi talep etme, (iii) işlenme
amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme (iv) yurt içinde /
yurt dışında aktarıldığı 3. kişileri bilme, (v) eksik / yanlış işlenmişse
düzeltilmesini isteme, (vi) KVKK m. 7'de öngörülen şartlar çerçevesinde
silinmesini / yok edilmesini isteme, (vii) verilerinizin aktarıldığı 3.
kişilere (v) ile (vi) bentlerindeki işlemlerin bildirilmesini isteme (viii)
münhasıran otomatik sistemler ile analiz edilmesi nedeniyle aleyhinize bir
sonucun ortaya çıkmasına itiraz etme ve (ix) kanuna aykırı olarak işlenmesi
sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme hakkına
sahipsiniz. Belirtilen haklarınıza ilişkin olarak Otosor'a yazılı olarak </span></span><span
                style='font-family:"Calibri","sans-serif"'><span lang=EN-GB
                                                                 style='font-family:"Source Sans Pro","serif"'>kvkk</span></span><span
                style='font-family:"Calibri","sans-serif"'><span lang=EN-GB
                                                                 style='font-family:"Source Sans Pro","serif"'>@otosor.com.tr </span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>e-posta adresimiz veya </span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'>“</span></span><span style='font-family:"Calibri","sans-serif"'><span
                lang=EN-GB style='font-family:"Source Sans Pro","serif"'>Ağaoğlu My Office İş
Merkezi Barbaros Mah. Lale Sok. No 2 Zemin Kat Bölüm 8 Ataşehir-İstanbul</span></span><span
                style='font-family:"Calibri","sans-serif"'><span lang=EN-GB
                                                                 style='font-family:"Source Sans Pro","serif"'>”</span></span><span
                style='font-family:"Calibri","sans-serif"'><span style='font-family:
"Source Sans Pro","serif"'> olan açık adresimiz üzerinden ulaşabilirsiniz.</span></span></p>

        <p class=MsoNormal><span style='font-family:"Calibri","sans-serif"'><span
                style='font-family:"Source Sans Pro","serif"'>&nbsp;</span></span></p>

    </div>
</div>`;
